import { FormatAPI } from "generated-api"
import { normalizeSync } from "normalize-diacritics"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import { IFormat, IFormatRepository } from "./model"

export const formatRPO: IFormatRepository = {
  getAllFormat(): Promise<IFormat[]> {
    return new Promise<IFormat[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        FormatAPI.getApiFormatList()
          .then(response =>
            resolve(
              response
                .filter(f => f.active && f.is_admin_dsp)
                .map(f => ({ ...f, normalizedName: !f.name ? "" : normalizeSync(f.name).toLowerCase() }))
            )
          )
          .catch((error: any) => {
            console.error("Server error while getting all formats", error)
            reject("format.get.all.error.server")
          })
      } catch (ex) {
        console.error("Server error while getting all formats", ex)
        reject("format.get.all.error.unexpected")
      }
    })
  }
}
